<template>
  <div class="wrapper" v-if="!fetching || data.length">
    <el-card class="wrap-tree" shadow="never">
      <div slot="header">系统菜单</div>
      <el-tree
        ref="tree"
        highlight-current
        :expand-on-click-node="false"
        class="tree"
        :data="data"
        :props="defaultProps"
        node-key="id"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="handleNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{node, data}">
          <icon-svg class="tree-node-icon" v-if="node.level === 2 && data.icon" :icon-class="data.icon"></icon-svg>
          <span class="custom-tree-node__label">{{node.label}}</span>
          <a v-if="data.pid !== '#' && node.level < 4" href="javascript: void 0" @click.stop="addMenu(node, data)">
            <icon-svg class="tree-node-icon" icon-class="plus"></icon-svg>
          </a>
          <a style="margin-left: 5px;" v-if="node.level !== 1 && node.level !== 2" href="javascript: void 0" @click.stop="deleteMenu(node, data)">
            <icon-svg class="tree-node-icon" icon-class="minus"></icon-svg>
          </a>
        </span>
      </el-tree>
    </el-card>
    <el-card class="wrap-form" :class="{'el-card--action-add': isAdd}">
      <div slot="header">{{isAdd ? '菜单添加' : '菜单维护'}}</div>
      <el-form
        :disabled="!form.menuPcode"
        :model="form"
        :rules="rules"
        ref="form"
        label-width="100px"
        @keydown.enter.native="onSubmit"
        :key="form.menuId"
      >
        <el-form-item label="上级菜单" prop="menuPcode">
          <el-input disabled :value="getParentMenu(form.menuPcode)"></el-input>
        </el-form-item>
        <el-form-item label="菜单名称" prop="name">
          <el-input v-model.trim="form.name" placeholder="请输入菜单显示名称"></el-input>
        </el-form-item>
        <el-form-item label="菜单地址" prop="url">
          <el-input v-model.trim="form.url" placeholder="请输入前端路由地址"></el-input>
        </el-form-item>
        <el-form-item v-if="formCurrentLevel === 2" label="菜单图标" prop="icon">
          <el-input v-model.trim="form.icon" placeholder="请输入前端图标类名"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="seqNum">
          <el-input v-model.trim="form.seqNum" placeholder="请输入菜单排序号(从大到小)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :loading="submitting" type="primary" @click="onSubmit">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {system} from '../../api'
import {getSession} from '../../utils/session'
import {ROLE_ID} from '../../constants'

const initForm = () => ({
  menuId: '',
  menuCode: '',
  icon: '',
  menuPcode: '',
  name: '',
  seqNum: '',
  url: ''
})

export default {
  name: 'MenuManagement',

  mounted () {
    this.initMenuTree()
  },

  data () {
    return {
      fetching: false,
      submitting: false,
      data: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      defaultExpandedKeys: [],
      form: initForm(),
      formCurrentLevel: 0,
      rules: {
        name: [
          {required: true, message: '请输入菜单名称', trigger: 'blur'}
        ],
        url: [
          {required: true, message: '请输入菜单地址', trigger: 'blur'}
        ],
        seqNum: [
          {type: 'string', pattern: /^-?[0-9]+$/, message: '请输入一个整数', trigger: 'blur'}
        ]
      }
    }
  },

  computed: {
    isAdd () {
      return this.form.menuPcode && !this.form.menuId
    }
  },

  methods: {
    addMenu (node, data) {
      this.$refs.form.resetFields()
      this.form = {
        ...initForm(),
        menuPcode: data.id,
        url: data.url
      }
      this.formCurrentLevel = node.level + 1
      // 当点击加号的时候，清空高亮
      this.$refs.tree.setCurrentKey(null)
    },
    deleteMenu (node, data) {
      console.log(node)
      let deleteId = data.id
      let roleId = getSession(ROLE_ID)
      this.$confirm('确定要删除这条菜单吗？', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let {code, msg} = await system.deleteMenu({
          roleId: roleId,
          menuCode: deleteId
        })
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '菜单删除成功'
          })
          this.updateTree(data.pid)
          // 如果删除的是当前节点，清空表单
          if (this.$refs.tree.getCurrentKey() === deleteId) {
            this.form = initForm()
            this.$refs.form.resetFields()
          }
        } else {
          this.$message({
            type: 'error',
            message: msg
          })
        }
      }, err => {
        console.log(err)
      })
    },
    findNodeByKey (data, value, key = 'id', children = 'children') {
      if (!data || data.length === 0) return null
      let found = data.find(x => x[key] === value)
      if (!found) {
        for (let item of data) {
          let cfound = this.findNodeByKey(item['children'], value, key, children)
          if (cfound) {
            found = cfound
            break
          }
        }
      }
      return found
    },
    searchMenuNameByCode (data, code) {
      let found = this.findNodeByKey(data, code)
      return found ? found.name : ''
    },
    getParentMenu (menuPcode) {
      if (this.data.length && menuPcode) {
        if (menuPcode === '#') return '根菜单'
        return this.searchMenuNameByCode(this.data, menuPcode)
      } else {
        return ''
      }
    },
    async initMenuTree () {
      this.fetching = true
      let {data} = await system.getMenuTree()
      this.fetching = false
      this.data = data
      // 默认展开根节点
      this.defaultExpandedKeys = [data[0].id]
    },
    handleNodeClick (data, node) {
      // 如果点击的为顶级节点，则改为增加新的节点
      if (node.level === 1) {
        return this.addMenu(node, data)
      }
      let {bizId, id, pid, name, orderNum, icon, url} = data
      let {level} = node
      this.$refs.form.resetFields()
      Object.assign(this.form, {
        menuId: bizId,
        menuCode: id,
        icon,
        menuPcode: pid,
        name,
        seqNum: String(orderNum || ''),
        url
      })
      this.formCurrentLevel = level
    },
    onSubmit () {
      if (this.submitting) return
      this.$refs.form.validate(async valid => {
        if (!valid) return
        let {menuId} = this.form
        this.submitting = true
        let {code, msg} = await system[menuId ? 'updateMenu' : 'addMenu'](this.form)
        this.submitting = false
        if (code === 0) {
          this.$message({
            type: 'success',
            message: menuId ? '菜单更新成功' : '菜单添加成功'
          })
          if (menuId) {
            this.updateTree(this.form.menuCode)
          } else {
            let toExpand = this.form.menuPcode
            await this.updateTree(this.form.menuPcode).then(() => {
              this.defaultExpandedKeys = [toExpand]
            })
            this.form = initForm()
            await this.$nextTick()
            this.$refs.form.resetFields()
            this.$refs.tree.setCurrentKey(null)
          }
        } else {
          this.$message({
            type: 'danger',
            message: msg
          })
        }
      })
    },
    async updateTree (menuCode) {
      let target = this.findNodeByKey(this.data, menuCode)
      let {data: newData} = await system.getMenuTree()
      let source = this.findNodeByKey(newData, menuCode)

      if ((!target.children || target.children.length === 0) && (source.children && source.children.length !== 0)) {
        let {children, ...others} = source
        Object.assign(target, others)
        this.$set(target, 'children', children)
      } else {
        Object.assign(target, ((!source.children || source.children.length === 0) ? {...source, children: []} : source))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
}
.wrap-tree {
  width: 280px;
  background-color: white;
  flex-shrink: 0;
}
.wrap-form {
  flex-grow: 1;
  margin-left: 10px;
}
</style>
